import React from 'react';

import { FormattedMessage } from 'react-intl-next';

// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { xcss } from '@atlaskit/primitives';
import Pressable from '@atlaskit/primitives/pressable';
import { token } from '@atlaskit/tokens';

import { feedbackButtonMessages } from './messages';

const feedbackButtonStyles = xcss({
	backgroundColor: 'color.background.neutral.subtle',
	color: 'color.link',
	font: token('font.body'),
	padding: 'space.0',
	':hover': {
		textDecoration: 'underline',
		cursor: 'pointer',
	},
});

const feedbackButtonSmallStyles = xcss({
	font: token('font.body.small'),
});

type FeedbackButtonProps = {
	onClick: (e: React.KeyboardEvent | React.MouseEvent) => void;
	size?: 'small' | 'medium';
};

export const FeedbackButton = ({
	onClick,
	size = 'medium',
}: FeedbackButtonProps): React.JSX.Element => (
	<Pressable
		xcss={[feedbackButtonStyles, size === 'small' && feedbackButtonSmallStyles]}
		onClick={onClick}
	>
		<FormattedMessage {...feedbackButtonMessages.feedbackButton} />
	</Pressable>
);
